// Allow Hot Module Replacement (HMR) for JS files
// For more details see https://vitejs.dev/guide/api-hmr.html
if (import.meta.hot) {
  import.meta.hot.accept();
}

import './text-media.scss';

document.querySelectorAll('.text-media p').forEach((p) => {
  const hasText = [...p.childNodes].some((n) => n.nodeType === 3 && n.textContent.trim());
  p.classList.toggle('containing-only-links', !hasText && p.querySelectorAll('a').length >= 2);
});
